import { motion } from 'framer-motion';

const TrustSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="font-serif text-4xl md:text-5xl font-bold text-purple-900 mb-12"
            >
              Built on Ethical AI Principles
            </motion.h2>

            <div className="grid grid-cols-3 gap-8 mb-12">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="text-center"
              >
                <div className="text-5xl font-bold text-purple-600 mb-2">100%</div>
                <div className="text-sm text-gray-600 font-medium">OECD Compliant</div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="text-center border-x border-gray-200"
              >
                <div className="text-5xl font-bold text-purple-600 mb-2">24/7</div>
                <div className="text-sm text-gray-600 font-medium">Always Available</div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 }}
                className="text-center"
              >
                <div className="text-5xl font-bold text-purple-600 mb-2">∞</div>
                <div className="text-sm text-gray-600 font-medium">Unlimited Wisdom</div>
              </motion.div>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="prose prose-lg"
            >
              <p className="text-gray-600 leading-relaxed mb-6">
                OhMyGAWD is built on the <strong className="text-purple-900">OECD AI Principles</strong>, ensuring our oracle operates with transparency, fairness, and respect for human values. We prioritize your privacy, security, and wellbeing in every interaction.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our AI is designed to provide <strong className="text-purple-900">guidance and inspiration</strong>, helping you explore possibilities and gain new perspectives on your journey. We combine cutting-edge technology with timeless wisdom traditions to create a unique spiritual experience.
              </p>
            </motion.div>
          </div>

          <div className="lg:col-span-2">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-purple-400 to-pink-400 rounded-3xl blur-3xl opacity-20"></div>
              <div className="relative bg-gradient-to-br from-lavender-100 to-purple-100 rounded-3xl p-12">
                <h3 className="font-serif text-3xl font-bold text-purple-900 mb-8">
                  Why People Trust OhMyGAWD
                </h3>
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl shadow-lg flex-shrink-0">
                      <i className="ri-shield-check-line text-2xl text-purple-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-purple-900 text-lg mb-2">Private & Secure</h4>
                      <p className="text-gray-700 leading-relaxed">Your questions and guidance remain completely confidential. We never share your personal queries or data.</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl shadow-lg flex-shrink-0">
                      <i className="ri-brain-line text-2xl text-purple-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-purple-900 text-lg mb-2">Advanced AI Technology</h4>
                      <p className="text-gray-700 leading-relaxed">Powered by cutting-edge AI that understands context, nuance, and delivers thoughtful, personalized responses.</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl shadow-lg flex-shrink-0">
                      <i className="ri-time-line text-2xl text-purple-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-purple-900 text-lg mb-2">Available 24/7</h4>
                      <p className="text-gray-700 leading-relaxed">Get guidance whenever you need it. No appointments, no waiting—instant wisdom at any time of day or night.</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl shadow-lg flex-shrink-0">
                      <i className="ri-heart-line text-2xl text-purple-600"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-purple-900 text-lg mb-2">Judgment-Free Zone</h4>
                      <p className="text-gray-700 leading-relaxed">Ask anything without fear of judgment. OhMyGAWD provides compassionate, unbiased guidance for all your questions.</p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;